import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  configureRootTheme,
  externalTheme
} from '@npm-registry/eapteka-ui';
import {
  getCartProductsCount,
  subscribeToCartUpdates
} from '@front-office/app-common-cart';
import { AppDispatch, fetchCart } from './store';
import { updateLoadingStatus } from './store/summary';
import {
  selectLoading,
  selectHasProducts
} from './store/products';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Fallback } from './components/elements/Fallback';
import { EmptyCartPage } from './components/layouts/EmptyCartPage';
import { CartPage } from './components/layouts/CartPage';

import './services/trackers/analytics.ts';
import './services/trackers/neon.ts';

configureRootTheme({ theme: externalTheme });

export const App = () => {
  const dispatch: AppDispatch = useDispatch();
  const predictCartCount = getCartProductsCount();
  const loading = useSelector(selectLoading);
  const hasProducts = useSelector(selectHasProducts);

  useEffect(() => {
    const updateItemEventsList = [
      'addItem',
      'removeItem',
      'setItemQuantity',
      'increaseItemQuantity',
      'decreaseItemQuantity'
    ];

    subscribeToCartUpdates((event) => {
      if ('data' in event.detail) {
        if ('collector' === event.detail.data.action) {
          dispatch(fetchCart());
        }

        if ('pushError' === event.detail.data.action) {
          // TODO: error message
        }

        if (
          updateItemEventsList.includes(
            event.detail.data.action
          )
        ) {
          dispatch(updateLoadingStatus('pending'));
        }
      }
    });

    //TODO unsubscribe
  }, []); // eslint-disable-line

  return (
    <ErrorBoundary fallback={<Fallback />}>
      {!predictCartCount ||
      (!hasProducts && loading != 'idle') ? (
        <EmptyCartPage />
      ) : (
        <CartPage predictCartCount={predictCartCount} />
      )}
    </ErrorBoundary>
  );
};
